import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import './navbar8.css'

const Navbar8 = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navLinks = [
    { to: "/", text: "Home" },
    { to: "/about", text: "About Us" },
    { to: "/initiatives", text: "Initiatives" },
    { to: "/members", text: "Members" },
    { to: "/contact", text: "Contact" },
    { to: "/resources", text: "Resources" },
  ]

  return (
    <header className="navbar8-container1">
      <header data-thq="thq-navbar" className="navbar8-navbar-interactive">
        <img alt={props.imageAlt} src={props.imageSrc} className="navbar8-image" />
        
        <div data-thq="thq-navbar-nav" className="navbar8-desktop-menu">
          <nav className="navbar8-links1">
            {navLinks.map((link, index) => (
              <Link key={index} to={link.to} className={`navbar8-link${index + 1}1`}>
                {props[`link${index + 1}`] ?? <span className={`navbar8-text${index + 1}4 thq-body-small thq-link`}>{link.text}</span>}
              </Link>
            ))}
          </nav>
          <div className="navbar8-buttons1">
            <Link to="/blog" className="navbar8-action11 thq-button-animated thq-button-filled">
              <span className="thq-body-small">Media &amp; News</span>
            </Link>
          </div>
        </div>
        <div
          data-thq="thq-burger-menu"
          className="navbar8-burger-menu"
          onClick={() => setMobileMenuOpen(true)}
        >
          <svg viewBox="0 0 1024 1024" className="navbar8-icon10">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className={`navbar8-mobile-menu ${mobileMenuOpen ? 'show' : ''}`}>
          <div className="navbar8-nav">
            <div className="navbar8-top">
              <div
                data-thq="thq-close-menu"
                className="navbar8-close-menu"
                onClick={() => setMobileMenuOpen(false)}
              >
                <svg viewBox="0 0 1024 1024" className="navbar8-icon12">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="navbar8-links2">
              {navLinks.map((link, index) => (
                <Link 
                  key={index} 
                  to={link.to} 
                  onClick={() => setMobileMenuOpen(false)}
                  className="navbar8-nav-link"
                >
                  {props[`link${index + 1}`] ?? <span className={`navbar8-text${index + 1}4 thq-body-small thq-link`}>{link.text}</span>}
                </Link>
              ))}
            </nav>
            <div className="navbar8-buttons2">
              <Link 
                to="/blog" 
                className="thq-button-filled" 
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="thq-body-small">Media &amp; News</span>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </header>
  )
}

Navbar8.defaultProps = {
  link4: undefined,
  page1ImageAlt: 'image',
  page3ImageSrc: 'https://images.unsplash.com/photo-1524448789231-1bb0771e7d45?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDd8fHJvdW5kfGVufDB8fHx8MTcxNjM5OTM0NHww&ixlib=rb-4.0.3&w=200',
  link1: undefined,
  linkUrlPage3: 'https://www.teleporthq.io',
  page4: undefined,
  action1: undefined,
  logoAlt: 'logo',
  link2Url: 'https://www.teleporthq.io',
  link3: undefined,
  page2ImageAlt: 'image',
  action2: undefined,
  link1Url: 'https://www.teleporthq.io',
  page1Description: undefined,
  linkUrlPage1: 'https://www.teleporthq.io',
  page3: undefined,
  page1: undefined,
  page4ImageAlt: 'image',
  link41: undefined,
  page2: undefined,
  page4ImageSrc: 'https://images.unsplash.com/photo-1605745141160-8892dc674e94?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDI0fHxyb3VuZHxlbnwwfHx8fDE3MTYzOTkzNDR8MA&ixlib=rb-4.0.3&w=200',
  linkUrlPage4: 'https://www.teleporthq.io',
  imageAlt: 'image',
  imageSrc: '/main-logo.png',
  page2ImageSrc: 'https://images.unsplash.com/photo-1618034100983-e1d78be0dc80?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE3fHxyb3VuZHxlbnwwfHx8fDE3MTYzOTkzNDR8MA&ixlib=rb-4.0.3&w=200',
  page3ImageAlt: 'image',
  page4Description: undefined,
  link3Url: 'https://www.teleporthq.io',
  logoSrc: '/main-logo.png',
  page3Description: undefined,
  page2Description: undefined,
  link2: undefined,
  linkUrlPage2: 'https://www.teleporthq.io',
  page1ImageSrc: 'https://images.unsplash.com/photo-1514285490982-4130e9aefedb?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fHJvdW5kfGVufDB8fHx8MTcxNjM5OTM0NHww&ixlib=rb-4.0.3&w=200',
}

Navbar8.propTypes = {
  link4: PropTypes.element,
  page1ImageAlt: PropTypes.string,
  page3ImageSrc: PropTypes.string,
  link1: PropTypes.element,
  linkUrlPage3: PropTypes.string,
  page4: PropTypes.element,
  action1: PropTypes.element,
  logoAlt: PropTypes.string,
  link2Url: PropTypes.string,
  link3: PropTypes.element,
  page2ImageAlt: PropTypes.string,
  action2: PropTypes.element,
  link1Url: PropTypes.string,
  page1Description: PropTypes.element,
  linkUrlPage1: PropTypes.string,
  page3: PropTypes.element,
  page1: PropTypes.element,
  page4ImageAlt: PropTypes.string,
  link41: PropTypes.element,
  page2: PropTypes.element,
  page4ImageSrc: PropTypes.string,
  linkUrlPage4: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  page2ImageSrc: PropTypes.string,
  page3ImageAlt: PropTypes.string,
  page4Description: PropTypes.element,
  link3Url: PropTypes.string,
  logoSrc: PropTypes.string,
  page3Description: PropTypes.element,
  page2Description: PropTypes.element,
  link2: PropTypes.element,
  linkUrlPage2: PropTypes.string,
  page1ImageSrc: PropTypes.string,
}

export default Navbar8